import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\theight: 100%;\n\tmin-height: ", ";\n\twidth: 100%;\n\tpadding: ", ";\n\tborder: 0;\n\tborder-bottom: ", ";\n\tborder-color: ", ";\n\tborder-radius: 0;\n\tbackground: transparent;\n\tcursor: ", ";\n\n\tcolor: ", ";\n\toutline: 0;\n\tfont-size: ", ";\n\n\tfont-family: inherit;\n\tmargin: ", " 0;\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t\toutline-style: solid;\n\t\toutline-width: 1px;\n\t\toutline-color: ", ";\n\t\toutline-offset: 2px;\n\t}\n\t&::-ms-clear {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { styled } from '../../theme-provider';
import { TextInputAppearance } from '../shared';
import { TextFieldCleanWrapper } from '../text-field-clean-wrapper';
import { TextFieldWrapper } from '../text-field-wrapper';
import { getColor } from '../utils'; // @todo get from theme

var borderSize = '1px';
var StyledInput = styled.input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-7giqxg"
})(_templateObject(), function (props) {
  return props.theme.size.static300;
}, function (props) {
  return props.icon ? "".concat(props.theme.size.static150, " ").concat(props.theme.size.static400) : "".concat(props.theme.size.static150, " 0");
}, function (_ref) {
  var appearance = _ref.appearance;
  return appearance !== TextInputAppearance.ReadOnly && "".concat(borderSize, " solid");
}, function (props) {
  var color = props.theme.interaction.recipe150.default;

  if (props.appearance === TextInputAppearance.Error) {
    color = props.theme.interaction.recipe360.default;
  } else if (props.appearance === TextInputAppearance.Success) {
    color = props.theme.interaction.recipe350.default;
  }

  return color;
}, function (props) {
  return props.appearance === TextInputAppearance.Disabled ? 'not-allowed' : '';
}, getColor, function (props) {
  return props.theme.textAppearances.copy0200.fontSize;
}, function (props) {
  return props.theme.size.static100;
}, function (props) {
  if (props.appearance === TextInputAppearance.Error || props.appearance === TextInputAppearance.Success) {
    return;
  }

  return props.theme.interaction.recipe150.checked;
}, function (props) {
  return props.theme.interaction.recipe100.active;
});
/* eslint-disable-next-line react/display-name */

export var TextInput = React.forwardRef(function (props, ref) {
  var additionalFeedback = props.additionalFeedback,
      appearance = props.appearance,
      errorText = props.errorText,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      icon = props.icon,
      onClear = props.onClear,
      hasClearButton = props.hasClearButton,
      isClearButtonVisible = props.isClearButtonVisible,
      _props$clearIconLabel = props.clearIconLabel,
      clearIconLabel = _props$clearIconLabel === void 0 ? '' : _props$clearIconLabel,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      value = props.value;
  return React.createElement(TextFieldWrapper, {
    appearance: appearance,
    label: label,
    errorText: errorText,
    value: value,
    required: required,
    icon: icon,
    additionalFeedback: additionalFeedback
  }, React.createElement(TextFieldCleanWrapper, {
    onClear: onClear,
    hasClearButton: hasClearButton,
    isClearButtonVisible: isClearButtonVisible,
    clearIconLabel: clearIconLabel
  }, React.createElement(StyledInput, Object.assign({}, props, {
    disabled: appearance === TextInputAppearance.Disabled,
    readOnly: appearance === TextInputAppearance.ReadOnly,
    ref: ref
  }))));
});